<template>
    <ProLink :to="to ? to : null" :href="href ? href : null" v-bind="$attrs" class="link-tile">
        <div class="link-tile__text" aria-hidden="true">
            <h2 class="link-tile__subheading text-subheading text-subheading--sm">{{ subheading }}<ProIcon v-if="arrow" icon="cta-right" /></h2>
            <p class="link-tile__heading text-heading text-heading--sm" v-html="heading"></p>
        </div>
        <div class="link-tile__image" aria-hidden="true">
            <slot default />
        </div>
    </ProLink>
</template>
<script>
export default {
    props: {
        to: Object,
        href: String,
        linkText: String,
        arrow: Boolean,
        subheading: String,
        heading: String,
    },
};
</script>
